import { AnimateIconBase } from '@consta/icons/AnimateIconBase'
import type { IconComponent } from '@consta/icons/Icon'
import type { FC } from 'react'
import { useState } from 'react'

import { IconResizerArrow, IconResizerBase } from '../../Icons'
import css from './ExpandButton.css'

const icons: IconComponent[] = [IconResizerBase, IconResizerArrow, IconResizerArrow]
const directionsAngles: number[] = [0, 0, 180]

type ExpandButtonProps = {
  expanded: boolean
  onClick?: VoidFunction
}

export const ExpandButton: FC<ExpandButtonProps> = ({ expanded, onClick }) => {
  const [activeIndex, setActiveIndex] = useState(0)

  return (
    <span
      className={css.button}
      onMouseOver={() => {
        setActiveIndex(expanded ? 2 : 1)
      }}
      onMouseOut={() => {
        setActiveIndex(0)
      }}
      onClick={() => {
        onClick?.()
        setActiveIndex(prev => (prev === 1 ? 2 : 1))
      }}>
      <AnimateIconBase
        size="s"
        activeIndex={activeIndex}
        icons={icons}
        directions={directionsAngles}
      />
    </span>
  )
}
